export default __webpack_public_path__ + "static/media/search.3b55cbfd.svg";